export default {
    data: `[
   {
      "universe":"nature_science",
      "translations":{
         
      }
   },
   {
      "universe":"world_history",
      "translations":{
         
      }
   },
   {
      "universe":"fiction",
      "translations":{
         
      }
   },
   {
      "universe":"generic",
      "translations":{
         
      }
   },
   {
      "universe":"alphabet_planet",
      "translations":{
         
      }
   }
]`
};


/** WEBPACK FOOTER **
 ** ./docs/universesList.js
 **/